import React from 'react';
import { Link } from 'react-router-dom';
import logo2 from '../assets/Footer-A-logo1.png';
import { FaFacebookF, FaInstagram, FaTwitter, FaLinkedinIn } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-[#0B2A2C] text-[#FFE286] font-poppins py-10 sm:py-12 md:py-16 px-6 sm:px-8 lg:px-12">
      <div className="max-w-7xl mx-auto flex flex-col gap-10 md:gap-12">

        {/* Top Section - UNCHANGED */}
        <div className="flex flex-col md:flex-row items-center md:items-start justify-center md:justify-start gap-4 md:gap-6 lg:gap-15">
          <div className="w-full md:w-auto md:ml-0 lg:ml-20 flex justify-center md:justify-start">
            <img
              src={logo2}
              alt="Ayusanjivni Logo"
              className="w-48 sm:w-56 md:w-[280px] lg:w-[340px] h-auto object-contain"
            />
          </div>

          <div className="hidden md:block w-[1px] h-16 sm:h-20 md:h-[80px] bg-[#FFE286]"></div>

          <div className="font-playfair text-2xl sm:text-3xl md:text-3xl leading-tight font-semibold flex flex-col text-center md:text-left">
            <p className="whitespace-pre-line">Find Your Flow,<br />Embrace Your Peace</p>
          </div>
        </div>
        {/* === MAIN GRID / FLEX CONTAINER === */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-10 lg:gap-12 items-start">

          {/* Quick Links */}
          <div className="text-center sm:text-left">
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-3 text-sm opacity-90 flex flex-col items-center sm:items-start">
              <li><Link to="/" className="hover:text-white transition-colors duration-300 hover:underline">Home</Link></li>
              <li><Link to="/about" className="hover:text-white transition-colors duration-300 hover:underline">About</Link></li>
              <li>
                <Link
                  to="/#services"
                  className="hover:text-white transition-colors duration-300 hover:underline"
                  onClick={(e) => {
                    if (window.location.pathname === '/') {
                      e.preventDefault();
                      document.getElementById('services')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                  }}
                >
                  Services
                </Link>
              </li>
              <li>
                <Link
                  to="/#retreats"
                  className="hover:text-white transition-colors duration-300 hover:underline"
                  onClick={(e) => {
                    if (window.location.pathname === '/') {
                      e.preventDefault();
                      document.getElementById('retreats')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                  }}
                >
                  Retreats
                </Link>
              </li>
                  <li>
      <Link
        to="/facilities"
        className="hover:text-white transition-colors duration-300 hover:underline"
      >
        Facilities
      </Link>
    </li>
              <li><Link to="/contact" className="hover:text-white transition-colors duration-300 hover:underline">Contact</Link></li>
            </ul>
          </div>

          {/* Membership */}
          <div className="text-center sm:text-left">
            <h4 className="text-lg font-bold mb-4">Membership</h4>
            <ul className="space-y-3 text-sm opacity-90 flex flex-col items-center sm:items-start">
              <li className="hover:text-white transition-colors duration-300">Practice</li>
              <li className="hover:text-white transition-colors duration-300">Corporate</li>
              <li className="hover:text-white transition-colors duration-300">Personal Training</li>
              <li className="hover:text-white transition-colors duration-300">Plans</li>
            </ul>
          </div>

          {/* Studio */}
          <div className="text-center sm:text-left">
            <h4 className="text-lg font-bold mb-4">Studio</h4>
            <ul className="space-y-3 text-sm opacity-90 flex flex-col items-center sm:items-start">
              <li className="hover:text-white transition-colors duration-300">Private Classes</li>
              <li className="hover:text-white transition-colors duration-300">Group Classes</li>
              <li className="hover:text-white transition-colors duration-300">Yoga Travel</li>
              <li className="hover:text-white transition-colors duration-300">Workshops</li>
            </ul>
          </div>

          {/* Get in touch */}
          <div className="text-center sm:text-left">
            <h4 className="text-lg font-bold mb-4">Get in touch</h4>
            <ul className="space-y-3 text-sm opacity-90 flex flex-col items-center sm:items-start">
              <li><Link to="/contact" className="hover:text-white transition-colors duration-300 hover:underline">Contact</Link></li>
              <li className="hover:text-white transition-colors duration-300">Free Trial</li>
              <li className="hover:text-white transition-colors duration-300">Careers</li>
            </ul>
          </div>

          {/* Connect + Admin Login */}
          <div className="flex flex-col items-center sm:items-end text-center sm:text-right gap-4">
            <h4 className="text-lg font-bold mb-2">Connect with us</h4>

            <div className="flex gap-6 text-2xl">
              <a href="https://www.instagram.com/srigayatriayusanjivni/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
                <FaInstagram />
              </a>
              <a href="#" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors opacity-50 cursor-not-allowed">
                <FaFacebookF />
              </a>
              <a href="#" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors opacity-50 cursor-not-allowed">
                <FaTwitter />
              </a>
              <a href="#" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors opacity-50 cursor-not-allowed">
                <FaLinkedinIn />
              </a>
            </div>

            <Link
              to="/admin"
              className="text-sm opacity-80 hover:opacity-100 hover:text-white underline underline-offset-4 hover:no-underline transition-all duration-300 mt-2"
            >
              Admin Login →
            </Link>
          </div>
        </div>
      </div>

      {/* Copyright Bar */}
      <div className="mt-10 md:mt-12 bg-[#0B1F21] py-4 text-center text-sm opacity-80">
        <p>© {new Date().getFullYear()} Ayusanjivni. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;